export default (that) => [
  {
    field: 'seq',
    width: 60,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
  },
  {
    field: 'displayImage',
    title: that.$l('INDEX.table_label_image') || '图片',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_fabricAgentName') || '业务人员',
    field: 'fabricAgentName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displaySeriesName') || '面料名称',
    field: 'displaySeriesName',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySeriesName' },
  },
  {
    title: that.$l('table_label_fabricSeriesStatus') || '状态',
    field: 'fabricSeriesStatus',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'fabricSeriesStatus' },
  },
  {
    title: that.$l('table_label_fabricContent') || '面料成分',
    field: 'fabricContent',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
  },
  // {
  //   title: that.$l('table_label_patternLabel') || '花型',
  //   field: 'patternLabel',
  //   minWidth: 150,
  //   align: 'left',
  //   showHeaderOverflow: true,
  // },
  {
    title: that.$l('table_label_techniqueLabel') || '工艺',
    field: 'techniqueLabel',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_functionLabel') || '功能',
    field: 'functionLabel',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  // {
  //   title: that.$l('table_label_constructionLabel') || '材料（面料卖点）',
  //   field: 'constructionLabel',
  //   minWidth: 160,
  //   align: 'left',
  //   showHeaderOverflow: true,
  // },
  {
    title: that.$l('table_label_displayWeight') || '面料克重',
    field: 'displayWeight',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayWeight' },
  },
  {
    title: that.$l('table_label_density') || '密度',
    field: 'density',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_yarnCount') || '纱支',
    field: 'yarnCount',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displaySubmitBy') || '提交审批人',
    field: 'displaySubmitBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displaySubmitBy' },
  },
  {
    title: that.$l('table_label_displayApprovalBy') || '审批人',
    field: 'displayApprovalBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayApprovalBy' },
  },{
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  }
]
